import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset } from '../../dataset/azure-data-lake-store-gen2-cosmos-structured-stream.dataset';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';


@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.copySourceType,
    display: [],
    tags: { datasetModel : Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset)}
})
export class AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource extends CopySource {
    public static readonly PARTITION_INDEX: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_INDEX',
        display: stringResources.AzureDataLakeStoreCosmosStructuredStream_PartitionIndex
    })
    public partitionIndex?: number;
}
